import { event } from "d3";
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class LdsEventBusService {
    private eventBus = {};
    public broadcastPool = [];

    constructor() { }

    startSubscribe(event, cb) {
        this.addTrigger(event, cb);
    }


    private addTrigger(event, cb) {
        if (!this.eventBus[event]) {
            this.eventBus[event] = {
                triggers: [cb]
            }
            return;
        }

        if (!this.eventBus[event].triggers) {
            this.eventBus[event].triggers = [cb];
            return;
        }

        let length = this.eventBus[event].triggers.length;
        this.eventBus[event].triggers[length] = cb;

        

        if (this.broadcastPool.includes(event)) {
            for (let i in this.eventBus[event].triggers) {
                if(!this.eventBus[event].triggers[i]){
                    continue;
                }
                this.eventBus[event].triggers[i](this.eventBus[event].data);
            }
        }

    }

    subscribeAll(events, cb) {
        for (let i = 0; i < events.length; i++) {
            const element = events[i];
            this.addTrigger(element, cb);
            cb(this.eventBus[element].data);
        }
    }

    broadcast(event, data?) {
        const eventObj = this.eventBus[event]
        if (eventObj) {
            eventObj.data = data;
            if (eventObj.triggers) {
                for (let i in eventObj.triggers) {
                    if (!this.eventBus[event]) break
                    eventObj.triggers[i](data);
                }
            } else {
                this.broadcastPool.push(event);
            }
        } else {
            this.eventBus[event] = {
                data: data
            };
        }
    }


    subscribe(event, cb) {
        this.startSubscribe(event, cb);
        cb(this.eventBus[event].data);
    }

    clearEvent(event) {
        this.eventBus[event] = undefined;
        this.broadcastPool[event] = undefined;
    }

    clearAll() {

    }

}
